import { EBitfStoreActions } from '@common/enums';
export enum EWebStoreActions {
  SET_PUBLIC_BUNDLES = 'SET_PUBLIC_BUNDLES',
  SET_GARAGE = 'SET_GARAGE',
  SET_PUBLIC_BUNDLE_LIST_SCROLL_Y_POSITION = 'SET_PUBLIC_BUNDLE_LIST_SCROLL_Y_POSITION',
  SET_VEHICLES_PRICE_LIST_SCROLL_Y_POSITION = 'SET_VEHICLES_PRICE_LIST_SCROLL_Y_POSITION',
}

export const eStoreActions = { ...EBitfStoreActions, ...EWebStoreActions };
